const STORAGE_KEY = 'brand-merge-selection';
const FORM_ID = 'merge-brands';
const ROW_CHECKBOX_SELECTOR = `input[type="checkbox"][form="${FORM_ID}"]`;
const SELECT_ALL_SELECTOR = 'input.js-select-all';
const COUNT_SELECTOR = '[data-bulk-selection-count]';
const BULK_ACTIONS_SELECTOR = '#bulk-actions-container';
const CONFIRM_FORM_ID = 'confirm-brand-merge';

function loadSelection() {
  try {
    const selection = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
    return new Set(Array.isArray(selection) ? selection : []);
  } catch (err) {
    return new Set();
  }
}

function saveSelection(selection) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...selection]));
}

function visibleCheckboxes() {
  return [...document.querySelectorAll(ROW_CHECKBOX_SELECTOR)];
}

function updateSelectionCount(selection) {
  const countEl = document.querySelector(COUNT_SELECTOR);
  if (!countEl) return;

  if (selection.size === 0) {
    countEl.textContent = '';
    return;
  }

  countEl.textContent = countEl.dataset.msg.replace('%(count)d', selection.size);
}

function updateBulkActionsVisibility(selection) {
  const bulkActionsEl = document.querySelector(BULK_ACTIONS_SELECTOR);
  if (!bulkActionsEl) return;

  bulkActionsEl.classList.toggle('d-none', selection.size === 0);
}

function updateSelectAll(selection) {
  const selectAll = document.querySelector(SELECT_ALL_SELECTOR);
  if (!selectAll) return;

  const boxes = visibleCheckboxes();
  const checkedCount = boxes.filter((box) => selection.has(box.value)).length;

  selectAll.checked = boxes.length > 0 && checkedCount === boxes.length;
  selectAll.indeterminate = checkedCount > 0 && checkedCount < boxes.length;
}

function syncFromStorage() {
  const selection = loadSelection();

  visibleCheckboxes().forEach((box) => {
    box.checked = selection.has(box.value);
  });
  updateSelectAll(selection);
  updateSelectionCount(selection);
  updateBulkActionsVisibility(selection);
}

// The ids are baked into the confirmation form's hidden inputs at this
// point, so any selection still in storage is a leftover and can go.
function clearStaleSelection() {
  if (
    document.getElementById(CONFIRM_FORM_ID) &&
    sessionStorage.getItem(STORAGE_KEY) !== null
  ) {
    sessionStorage.removeItem(STORAGE_KEY);
  }
}

function initFromStorage() {
  clearStaleSelection();
  syncFromStorage();
}

document.addEventListener('DOMContentLoaded', initFromStorage);
document.addEventListener('htmx:load', initFromStorage);

document.addEventListener('change', (event) => {
  const selection = loadSelection();

  if (event.target.matches(SELECT_ALL_SELECTOR)) {
    visibleCheckboxes().forEach((box) => {
      if (event.target.checked) {
        selection.add(box.value);
      } else {
        selection.delete(box.value);
      }
    });
    saveSelection(selection);
    syncFromStorage();
    return;
  }

  if (event.target.matches(ROW_CHECKBOX_SELECTOR)) {
    if (event.target.checked) {
      selection.add(event.target.value);
    } else {
      selection.delete(event.target.value);
    }
    saveSelection(selection);
    updateSelectAll(selection);
    updateSelectionCount(selection);
    updateBulkActionsVisibility(selection);
  }
});

function injectHiddenSelection(form, selection) {
  // Remove inputs left over from a previous submission attempt.
  form.querySelectorAll('input[type="hidden"][data-bulk-selection]').forEach((input) => {
    input.remove();
  });
  selection.forEach((id) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'id';
    input.value = id;
    input.setAttribute('data-bulk-selection', '');
    form.appendChild(input);
  });
}

// Fallback for submissions when htmx is not handling the form.
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (form.id !== FORM_ID) return;

  // When htmx has taken over the submission it has already called
  // preventDefault(); the request is handled through the htmx events below.
  if (event.defaultPrevented) return;

  const selection = loadSelection();
  if (selection.size < 2) {
    event.preventDefault();
    return;
  }

  // The form only contains the checkboxes of the current page, so submit the
  // full selection kept across pages as hidden inputs.
  injectHiddenSelection(form, selection);
  sessionStorage.removeItem(STORAGE_KEY);
});

document.addEventListener('htmx:confirm', (event) => {
  if (event.target.id !== FORM_ID) return;

  // Guard the batch action before the confirmation dialog is shown.
  if (loadSelection().size < 2) {
    event.preventDefault();
  }
});

document.addEventListener('htmx:configRequest', (event) => {
  if (event.target.id !== FORM_ID) return;

  // Only the checkboxes of the current page are serialized with the form,
  // add the ids kept across paginated pages so they are merged as well.
  const parameters = event.detail.parameters;
  const serialized = Array.isArray(parameters.id)
    ? parameters.id
    : parameters.id
      ? [parameters.id]
      : [];
  const ids = new Set(serialized);
  loadSelection().forEach((id) => ids.add(id));
  parameters.id = [...ids];

  // The selection is part of the request now, so clear it. Clearing it
  // here instead of in htmx:afterRequest also covers the swap replacing
  // the form, which keeps afterRequest from reaching this script with the
  // form as the target.
  sessionStorage.removeItem(STORAGE_KEY);
});
